// extracted by mini-css-extract-plugin
export default {"menuBlock":"IJ-z","title":"JJ-z","nav":"KJ-z","flexCell":"LJ-z","facetLink":"MJ-z"};